import { alpha } from '@mui/material/styles';

/**
 * Subtle, theme-aware scrollbar for narrow panels (e.g. sidebar nav).
 */
export function getSidebarScrollbarStyles(theme) {
    const thumbOpacity = theme.palette.mode === 'dark' ? 0.22 : 0.2;
    const thumbHoverOpacity = theme.palette.mode === 'dark' ? 0.38 : 0.32;
    const thumb = alpha(theme.palette.text.primary, thumbOpacity);
    const thumbHover = alpha(theme.palette.text.primary, thumbHoverOpacity);

    return {
        scrollbarWidth: 'thin',
        scrollbarColor: `${thumb} transparent`,
        '&::-webkit-scrollbar': {
            width: 6,
        },
        '&::-webkit-scrollbar-track': {
            backgroundColor: 'transparent',
        },
        '&::-webkit-scrollbar-thumb': {
            backgroundColor: thumb,
            borderRadius: 8,
            border: '2px solid transparent',
            backgroundClip: 'padding-box',
            transition: 'background-color 0.2s ease',
            '&:hover': {
                backgroundColor: thumbHover,
            },
        },
        '&::-webkit-scrollbar-corner': {
            backgroundColor: 'transparent',
        },
    };
}
